import React, { FC, useState, ReactElement } from 'react';
import { useDispatch } from 'react-redux';

import DeleteButton from '../DeleteButton';
import { ButtonTypes } from '@ad-scripts/presentation/components/common/button';
import { StyledConfirmOrCancelModal } from './StyledConfirmOrCancelModal';

export type DeleteProps = {
  confirmationText?: string;
  deleteAction?: Function;
  deleteIcon?: any;
  description?: string | ReactElement;
  handleOpenModal?: Function;
  id: string;
  onDelete?: Function;
  submitText?: string;
  cancelText?: string;
};

const Delete: FC<DeleteProps> = ({
  children,
  confirmationText,
  deleteAction,
  deleteIcon,
  description,
  handleOpenModal,
  id,
  onDelete,
  submitText,
  cancelText,
}) => {
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
  const dispatch = useDispatch();

  const openModal = function () {
    if (handleOpenModal) {
      return handleOpenModal(() => setIsDeleteModalVisible(true));
    }
    setIsDeleteModalVisible(true);
  };

  const handleCancel = function () {
    setIsDeleteModalVisible(false);
  };
  const handleSubmit = function () {
    if (onDelete) {
      onDelete({ id });
    } else if (deleteAction) {
      dispatch(deleteAction({ id }));
    }
    setIsDeleteModalVisible(false);
  };
  return (
    <>
      <DeleteButton id={id} onClick={openModal} icon={deleteIcon} />
      {isDeleteModalVisible ? (
        <StyledConfirmOrCancelModal
          cancelText={cancelText}
          children={children}
          onCancel={handleCancel}
          onSubmit={deleteAction || onDelete ? handleSubmit : undefined}
          submitButtonType={ButtonTypes.DANGER}
          cancelButtonType={deleteAction ? ButtonTypes.TEXT : ButtonTypes.SECONDARY}
          submitText={submitText}
          text={description}
          title={confirmationText}
        />
      ) : null}
    </>
  );
};

export { Delete };
